import React from 'react';
import { AppButton, Box, costFormater, Inscription } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { useContentAreaBounds } from '../hooks';

import { Divider, FixedBar } from './ApplyFundsBar.styles';

interface Props {
  selectedCount: number;
  selectedAmount: number;
  balanceAfterApply: number;
  isApplying?: boolean;
  onClear: () => void;
  onApply: () => void;
}

const ApplyFundsBar: React.FC<Props> = ({
  selectedCount,
  selectedAmount,
  balanceAfterApply,
  isApplying,
  onClear,
  onApply,
}) => {
  const hasSelection = selectedCount > 0;
  const bounds = useContentAreaBounds();

  return (
    <FixedBar
      data-testid="apply-funds-bar"
      align="center"
      background="canvas"
      pad={{ vertical: 'spacing16' }}
      height={{ min: '80px' }}
      $left={bounds?.left}
      $width={bounds?.width}
    >
      <Box direction="row" align="center" justify="between" width={theme.defaultContentWidth}>
      {hasSelection ? (
        <Box direction="row" align="center" gap="spacing32">
          <Box gap="spacing2">
            <Inscription size="small" weight={500} color="textSecondary" whiteSpace="nowrap" lineHeight="18px">
              Selected (<span data-testid="apply-funds-bar_selected-count">{selectedCount}</span>)
            </Inscription>
            <Inscription
              data-testid="apply-funds-bar_selected-amount"
              size="xxlarge"
              lineHeight="28px"
              weight="bold"
              color="textBody"
            >
              {costFormater(selectedAmount, true)}
            </Inscription>
          </Box>
          <Divider />
          <Box gap="spacing2">
            <Inscription size="small" weight={500} color="textSecondary" whiteSpace="nowrap" lineHeight="18px">
              Balance after applied
            </Inscription>
            <Inscription
              data-testid="apply-funds-bar_balance-after"
              size="xxlarge"
              lineHeight="28px"
              weight="bold"
              color="textBody"
            >
              {costFormater(balanceAfterApply, true)}
            </Inscription>
          </Box>
        </Box>
      ) : (
        <Inscription data-testid="apply-funds-bar_hint" size="medium" color="textSecondary">
          Select invoices to apply funds
        </Inscription>
      )}
      <Box direction="row" gap="spacing12">
        <AppButton
          testId="apply-funds-bar_clear"
          buttonType="secondary"
          width="120px"
          disabled={!hasSelection || isApplying}
          onClick={onClear}
        >
          Clear
        </AppButton>
        <AppButton testId="apply-funds-bar_apply" width="195px" disabled={!hasSelection || isApplying} onClick={onApply}>
          {hasSelection ? `Apply ${costFormater(selectedAmount, true)}` : 'Apply'}
        </AppButton>
      </Box>
      </Box>
    </FixedBar>
  );
};

export default ApplyFundsBar;
